import Checkbox from '@components/checkbox';
import React, {useContext} from 'react';
import {DataContext} from 'contexts';
import * as PropTypes from 'prop-types';

const AllFirmsSelectionCheckbox = ({children, className, showCount}) => {
    const { searchResults, handleAllSearchResultsSelection, isUser, licenseInfo, isOutsideRussia} = useContext(DataContext);

    const searchResultsSelectedCount = searchResults?.result?.filter(r => r.isSelected).length || 0;
    const searchResultsLength = searchResults?.result?.length || 0;

    return (
        <Checkbox
	        checked={searchResultsSelectedCount !== 0 && (searchResultsSelectedCount === showCount || searchResultsSelectedCount === searchResultsLength)}
            className={className}
            disabled={searchResultsLength === 0 || !isUser || (!licenseInfo?.searchAccessFinishUtc && !isOutsideRussia)}
            size="small"
            onChange={event => handleAllSearchResultsSelection(event.target.checked)}
        >
	        {children}
        </Checkbox>
    );
};


AllFirmsSelectionCheckbox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    showCount: PropTypes.number,
};


export default AllFirmsSelectionCheckbox;
